import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyleForm = styled.div`
    form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .form__validate-form {
        margin-top: 3rem;
        display: flex;
        justify-content: space-around;
    }

    .form__validate-form > .validate-form__field {
        border: none;
        width: 40px;
        height: 50px;
        padding: 0 5px;
        font-size: 2rem;
        border-bottom: solid 1px #666;
        font-weight: ${theme.fontWeights.bold};
        font-family: 'Dasa Sans', 'Montserrat', sans-serif;
        text-align: center;
        appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        color: #363636;

        &:focus {
            outline: none;
            border-bottom-color: ${theme.colors.brand.primary[50]};
        }
        &--success,
        &--success:focus {
            border-bottom-color: #22723a;
        }
        &--error,
        &--error:focus {
            border-bottom-color: #c02a3c;
        }
    }

    .form__validate-form__footer {
        margin-top: 132px;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        justify-content: space-between;
    }

    .footer__paragraph {
        width: 100%;
        text-align: center;
        font-family: 'Dasa Sans', 'Montserrat', sans-serif;
        color: ${theme.colors.grays[40]};
        font-size: ${theme.fontSizes[1]};
    }

    .footer__button {
        border: none;
        width: 100%;
        background-color: initial;
        font-size: ${theme.fontSizes[1]};
        font-family: 'Dasa Sans', 'Montserrat', sans-serif;
        color: ${theme.colors.brand.primary[50]};
        cursor: pointer;
        text-decoration: underline;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 434px;

        form {
            display: initial;
            height: initial;
        }
    }
`
